import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'src/store';
import { getStringrWithoutTags, removeVariables } from 'src/utils/index';
import { InfoIconSvg } from 'src/assets/index';
import { getNotificationBar, INotificationBarState } from 'src/store/slices/index';
import './style.scss';

interface IMapStateToProps {
  notificationBarStore: INotificationBarState;
}

interface IMapDispatchToProps {
  getNotificationBar: () => void;
}

interface IProps extends IMapStateToProps, IMapDispatchToProps {}

const ZERO = 0;

export class NotificationBarComponent extends React.Component<IProps, null> {
  componentDidMount(): void {
    this.props.getNotificationBar();
  }

  render(): React.ReactNode {
    const { notificationBarStore } = this.props;
    const { notificationBar, loading } = notificationBarStore;

    const isTitleAvailable =
      notificationBar && !!getStringrWithoutTags(notificationBar[ZERO].title.rendered).length;
    const isContentAvailable =
      notificationBar && !!getStringrWithoutTags(notificationBar[ZERO].content.rendered).length;

    return notificationBar &&
      !!notificationBar.length &&
      (isTitleAvailable || isContentAvailable) &&
      !loading ? (
      <div className="notification-bar">
        <div className="notification-bar__wrapper">
          <div>
            <InfoIconSvg />
            {isTitleAvailable ? (
              <div
                className="notification-bar__title"
                dangerouslySetInnerHTML={{
                  __html: removeVariables(notificationBar[ZERO].title.rendered),
                }}
              />
            ) : null}
          </div>
          {isContentAvailable ? (
            <div
              className="notification-bar__description"
              dangerouslySetInnerHTML={{
                __html: removeVariables(notificationBar[ZERO].content.rendered),
              }}
            />
          ) : null}
        </div>
      </div>
    ) : null;
  }
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    notificationBarStore: state.notificationBarStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  getNotificationBar,
};

export const NotificationBar = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationBarComponent);
